import { formatHumanName } from "@medplum/core";
import type { PatientDto } from "@repo/data-store";

/** The one formatter for patient names. Undefined when there is nothing to show, so each caller picks its own fallback. */
export function patientDisplayName(p: Pick<PatientDto, "name" | "otherNames"> | null | undefined): string | undefined {
  if (!p) return undefined;
  const legal = formatHumanName(p.name).trim();
  const preferred = (p.name.use === "usual" ? p.name : p.otherNames?.find((name) => name.use === "usual"))?.given
    ?.join(" ")
    .trim();
  return (preferred && preferred !== p.name.given?.[0] ? `${preferred} (${legal})` : legal) || undefined;
}

export function getPatientName(patient: PatientDto): string {
  return patientDisplayName(patient) ?? "Unknown";
}

/** Get MRN (Medical Record Number) from patient identifiers */
export function getMRN(patient: PatientDto): string {
  const mrn = patient.identifiers?.find((id) => id.use === "official" || id.system?.endsWith("/mrn"));
  return mrn?.value || "-";
}
